import { UserRolesEnum } from "../../../pages/auth/userRoles.enum";

// Who an article is shown to. Each list mirrors the ProtectedRoute guard of
// the page the article explains (src/app/Routes.js), so nobody reads a guide
// for a page they would only reach as /unauthorized.

export const ACCOUNT_ROLES = [
   UserRolesEnum.SuperAdmin,
   UserRolesEnum.Organization,
   UserRolesEnum.AdminOfOrganization,
   UserRolesEnum.SeniorProjectManager,
   UserRolesEnum.ProjectManager,
   UserRolesEnum.JuniorProjectManager
];

export const TEAM_ROLES = [
   UserRolesEnum.SuperAdmin,
   UserRolesEnum.Organization,
   UserRolesEnum.AdminOfOrganization,
   UserRolesEnum.SeniorProjectManager
];

// Everyone who manages surveys: every account role except the Junior Manager.
export const MANAGER_ROLES = ACCOUNT_ROLES.filter(
   (role) => role !== UserRolesEnum.JuniorProjectManager
);

export const WORKSPACE_ROLES = [...ACCOUNT_ROLES, UserRolesEnum.Guest];

export const TICKET_ROLES = WORKSPACE_ROLES;

export const BILLING_ROLES = [UserRolesEnum.Organization];

export const DATA_COLLECTOR_ROLES = [UserRolesEnum.DataCollector];
